<div>
  @for (leg of legs; track leg; let i = $index; let first = $first) {
    <div class="leg">
      <div class="leg_header_container">
        <section (mouseleave)="tt.close()" class="container">
          <div
            ngbTooltip="{{ busToolTip }}"
            attr.aria-label="{{ busToolTip }}"
            class="leg_header"
            triggers="manual"
            #tt="ngbTooltip"
            (mouseenter)="busToolTip ? tt.open() : null"
            (focus)="busToolTip ? tt.open() : null"
            (blur)="tt.close()"
          >
            <strong class="tourOpId">{{ leg.touropIDFull }}</strong>
            <span>{{ leg.transNo }}</span>
          </div>
        </section>
        <div class="leg_header">
          @if (trainNumber) {
            <span class="codeshare">
              <span i18n="@@irlLegsEquipmentBy"> Train number:</span>
              {{ trainNumber }}
            </span>
          }
          <br />
        </div>
      </div>
      <div class="flex-row-container amenities-leg-container">
        <div class="leg_trip">
          <span id="start_location" class="leg_start_location">
            <strong>{{ leg.depart }}</strong>
            <br />
            <em>
              {{ leg.departDateTime | sabsDate: 1 }}
            </em>
          </span>
          <span class="leg_start_time">{{ leg.departDateTime | sabsTimePipe: 'timeString' }}</span>
          @if (leg.operator === 'Coach') {
            <span class="bus-route">
              <i class="ico ico-bus"></i
              ><span i18n="@@railBus"> - This leg is operated by a bus.</span>
            </span>
          }
          <span id="end_location" class="leg_end_location">
            <strong>{{ leg.arrive }}</strong>
            <br />
            <em>
              {{ leg.arriveDateTime | sabsDate: 1 }}
            </em>
            <br />
            <span class="leg_time"
              ><time
                >Duration:
                {{
                  getTimeDifference(leg.departDateTime, leg.arriveDateTime)
                    | sabsTimePipe: 'min_duration'
                }}</time
              ></span
            >
          </span>
          @if (co2Aray) {
            <span class="leg_c02">CO2 {{ co2Aray[i] }} Kg pp</span>
          }
          <span class="leg_end_time">{{ leg.arriveDateTime | sabsTimePipe: 'timeString' }}</span>
          <div class="leg_line">
            <div class="leg_line_line"></div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
